export default __webpack_public_path__ + "static/media/provesional_restoration_upper_18_4@2x.8867c1d7.png";